import { render, staticRenderFns } from "./EditTestConfigModal.vue?vue&type=template&id=2fc64483&"
import script from "./EditTestConfigModal.vue?vue&type=script&lang=js&"
export * from "./EditTestConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTestConfigModal.vue?vue&type=style&index=0&id=2fc64483&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports